module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.561329a.woff2";